import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import { usePermissions } from "@/hooks/usePermissions";

/** Effective org flag (matrix → associate inheritance). */
export function useRestrictedConversationVisibility() {
  const { activeWorkspaceId, userRole } = useAuth();
  const { can } = usePermissions();
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!activeWorkspaceId) {
      setEnabled(false);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    void (async () => {
      const { data, error } = await supabase.rpc(
        "effective_restricted_conversation_visibility" as never,
        { p_org_id: activeWorkspaceId } as never,
      );
      if (!cancelled) {
        if (error) {
          console.warn("effective_restricted_conversation_visibility:", error.message);
          setEnabled(false);
        } else {
          setEnabled(!!data);
        }
        setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [activeWorkspaceId]);

  // Legacy agents get conversations.view_all via has_permission fallback; when the
  // org flag is on they must still be treated as restricted (mirrors SQL helper).
  const isLegacyAgentRole = userRole === "agent" || userRole === "agente";
  const agentInboxRestricted =
    !can("conversations.view_all") || (enabled && isLegacyAgentRole);

  return { enabled, loading, agentInboxRestricted };
}
